import { DocumentVersion } from '@alucio/aws-beacon-amplify/src/models'
import { DBSchema } from 'idb'

export enum CACHE_STATUS {
  REQUESTED = 'REQUESTED',
  LOADED = 'LOADED',
  FAILED = 'FAILED',
}

export enum CONTENT_CACHE_TYPE {
  CONTENT = 'CONTENT',
  THUMBNAIL = 'THUMBNAIL',
  PAGES_JSON = 'PAGES_JSON',
  HTML_MANIFEST = 'HTML_MANIFEST',
}

export enum CacheDB {
  DB_NAME = 'CacheDB',
  CACHE_MANIFEST = 'CACHE_MANIFEST',
  CACHE_PAYLOAD = 'CACHE_PAYLOAD',
}

export interface DocumentVersionsCacheEntriesMap {
  [documentVersionId: string]: {
    content?: CacheManifestEntry,
    pagesJson?: CacheManifestEntry,
    htmlManifest?: CacheManifestEntry,
    thumbnail?: CacheManifestEntry,
  }
}

export interface CacheManifestEntry {
  id: string;
  documentId: string,
  documentVersionId: string,
  versionNumber: number,
  status: CACHE_STATUS | keyof typeof CACHE_STATUS,
  cacheType: CONTENT_CACHE_TYPE | keyof typeof CONTENT_CACHE_TYPE,
  type: DocumentVersion['type'],
  folderKey: string,
  fileKey: string,
  fileSize: number,
  requestedAt: Date,
  loadedAt?: Date,
}

export interface CachePayload {
  id: string,
  path: string
  data: ArrayBuffer;
  cacheType: CONTENT_CACHE_TYPE | keyof typeof CONTENT_CACHE_TYPE;
  size: number;
  mimeType: string,
}

export interface CacheDBSchema extends DBSchema {
  CACHE_MANIFEST: {
    key: string,
    value: CacheManifestEntry,
    indexes: { 'by-status': CACHE_STATUS },
  };

  CACHE_PAYLOAD: {
    value: CachePayload,
    key: string,
    indexes: { 'by-path': string };
  };
}
